import { render } from "./view-client-type.vue?vue&type=template&id=8144d11a&lang=html"
import script from "./view-client-type.vue?vue&type=script&lang=js"
export * from "./view-client-type.vue?vue&type=script&lang=js"

import "./view-client-type.vue?vue&type=style&index=0&id=8144d11a&lang=less"

import exportComponent from "/opt/nexus/frontend/v1/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__